import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { View } from 'foundations-components/transitional/components/View';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-ignore Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CertificationsFilter = ({
  appearsIn
}) => {
  const [[hasCertification], setHasCertification] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const handleCertificationChange = checked => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: checked ? 'filter-selected' : 'filter-deselected',
      value: hasCertification,
      isDropdown: false,
      key: 'certifications-filter',
      appearsIn
    });
    setHasCertification(checked ? 'ONLY_SHOW_CERTIFICATE_COURSES' : undefined);
  };
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: "300",
    children: [/*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "certifications-filter",
      paddingBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyComponents.topFilters.certifications.filterTitle"
      })
    }), /*#__PURE__*/_jsx(Toggle, {
      checked: hasCertification === 'ONLY_SHOW_CERTIFICATE_COURSES',
      "data-test-id": "filter-type-awardType",
      id: "certifications-filter",
      onChange: ({
        target: {
          checked
        }
      }) => handleCertificationChange(checked),
      size: "extra-small"
    })]
  });
};